{
  "tabs": {
    "chat": "Chat",
    "reminders": "Připomínky",
    "calendar": "Kalendář",
    "settings": "Nastavení"
  },
  "common": {
    "cancel": "Zrušit",
    "save": "Uložit",
    "confirm": "Potvrdit",
    "delete": "Smazat",
    "back": "Zpět",
    "close": "Zavřít",
    "edit": "Upravit",
    "search": "Hledat",
    "all": "Vše",
    "loading": "Načítám...",
    "error": "Něco se pokazilo",
    "notFound": "Nenalezeno",
    "tryAgain": "Zkuste to znovu",
    "retry": "Zkusit znovu",
    "undo": "Zpět",
    "pullToRefresh": "Táhněte pro obnovení",
    "justNow": "právě teď"
  },
  "auth": {
    "welcome": "Vítejte ve FishMemory",
    "tagline": "Váš WhatsApp asistent pro připomínky, nyní v kapse.",
    "subtitle": "Váš WhatsApp asistent pro připomínky, nyní v kapse.",
    "phoneLabel": "Vaše WhatsApp číslo",
    "phoneHint": "Pošleme ověřovací kód přes WhatsApp",
    "invalidPhone": "Zadejte platné telefonní číslo",
    "continue": "Pokračovat",
    "enterPhone": "Zadejte své WhatsApp číslo",
    "phonePlaceholder": "Telefonní číslo",
    "sendCode": "Poslat kód",
    "verifyTitle": "Ověřte své číslo",
    "otpSentTo": "6místný kód byl odeslán na {{phone}} přes WhatsApp",
    "enterFullCode": "Zadejte všech 6 číslic",
    "invalidOtp": "Neplatný kód. Zkuste to znovu.",
    "otpFailed": "Nepodařilo se odeslat kód. Zkuste to znovu.",
    "otpResent": "Kód znovu odeslán",
    "resendIn": "Znovu za {{seconds}}s",
    "resendCode": "Znovu poslat kód",
    "enterOtp": "Zadejte kód zaslaný na WhatsApp",
    "verify": "Ověřit",
    "resend": "Znovu poslat kód",
    "wrongNumber": "Špatné číslo?",
    "backToPhone": "Zpět k číslu",
    "editPhone": "Upravit číslo",
    "error": "Chyba",
    "setupTitle": "Nastavme to",
    "setupSubtitle": "Tyto údaje můžete kdykoli změnit v Nastavení",
    "namePlaceholder": "Vaše jméno",
    "letsGo": "Dokončit nastavení",
    "skipForNow": "Přeskočit"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Napište zprávu...",
    "inputPlaceholder": "Napište zprávu...",
    "typing": "FishMemory píše...",
    "online": "Online",
    "connecting": "Připojuji se...",
    "reconnecting": "Znovu se připojuji...",
    "offline": "Offline",
    "empty": "Začněte konverzaci",
    "emptyHint": "Vytvářejte připomínky, kontrolujte plán nebo požádejte o pomoc.",
    "emptyAction": "Poslat ukázkovou připomínku",
    "actions": "Akce chatu",
    "keep": "Uložit zprávy",
    "clearTitle": "Vymazat chat",
    "clearConfirm": "Smazat všechny zprávy z tohoto zařízení? Nelze vrátit zpět.",
    "clear": "Vymazat chat",
    "optionSelected": "Vybráno: {{label}}",
    "sendingSelection": "Odesílám...",
    "connectionLost": "Znovu se připojuji..."
  },
  "reminders": {
    "title": "Moje připomínky",
    "active": "Aktivní",
    "today": "Dnes",
    "thisWeek": "Tento týden",
    "history": "Historie",
    "items": "položek",
    "emptyTitle": "Žádné připomínky",
    "emptySubtitle": "Vytvořte připomínku v chatu a zobrazí se zde.",
    "emptyAction": "Otevřít chat",
    "filterActive": "Aktivní",
    "filterToday": "Dnes",
    "filterWeek": "Tento týden",
    "filterHistory": "Historie",
    "emptyState": "Žádné připomínky. Začněte chatovat!",
    "swipeDone": "Hotovo",
    "swipeSnooze": "Odložit",
    "swipeDelete": "Smazat",
    "search": "Hledat připomínky...",
    "upcoming": "Blíží se",
    "completed": "Dokončené",
    "overdue": "Po termínu",
    "tomorrow": "Zítra",
    "synced": "Synchronizováno {{value}}",
    "swipeHint": "Přejeďte připomínku pro další akce",
    "noResults": "Žádné připomínky neodpovídají hledání",
    "noResultsHint": "Zkuste jiné klíčové slovo nebo vymažte hledání",
    "deleteAllFailed": "Nepodařilo se smazat všechny připomínky"
  },
  "calendar": {
    "title": "Kalendář",
    "today": "Dnes",
    "tomorrow": "Zítra",
    "completed": "hotovo",
    "noEvents": "Žádné události",
    "noEventsSubtitle": "Vyberte datum pro zobrazení připomínek a událostí.",
    "googleEvent": "Google Kalendář",
    "legendActive": "Aktivní",
    "legendRecurring": "Opakující se",
    "legendDone": "Hotovo",
    "legendGoogle": "Google",
    "previousMonth": "Předchozí měsíc",
    "nextMonth": "Další měsíc",
    "previousYear": "Předchozí rok",
    "nextYear": "Další rok",
    "goToToday": "Jít na dnešek",
    "all": "Vše",
    "active": "Aktivní",
    "done": "Hotovo",
    "paused": "Pozastaveno"
  },
  "settings": {
    "title": "Nastavení",
    "profile": "Profil",
    "name": "Zobrazované jméno",
    "enterName": "Zadejte své jméno",
    "language": "Jazyk",
    "uiLanguage": "Jazyk aplikace",
    "uiLanguageHelp": "Změní jazyk rozhraní, popisky kalendáře a směr rozložení pouze na tomto zařízení.",
    "serverLanguage": "Jazyk chatu",
    "serverLanguageHelp": "Změní jazyk odpovědí serveru a zpráv připomínek pro váš účet.",
    "timezone": "Časové pásmo",
    "currentTimezone": "Aktuální časové pásmo",
    "timezoneHelp": "Všechny časy připomínek jsou zobrazeny v tomto časovém pásmu.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Uložit časové pásmo",
    "timezoneSaved": "Časové pásmo aktualizováno",
    "detect": "Detekovat",
    "detectFailed": "Nepodařilo se detekovat časové pásmo",
    "autoDetect": "Automaticky z GPS",
    "notifications": "Oznámení",
    "notificationsHelp": "Opakované připomínky ovládají opakované upozornění po doručení. Oprávnění oznámení zařízení spravujete v nastavení telefonu.",
    "pushEnabled": "Push oznámení",
    "autoDoneOnFire": "Automaticky označit jako hotové při spuštění",
    "autoDoneOnFireDesc": "Když vypnuto, připomínky zůstávají aktivní, dokud je neoznačíte jako hotové.",
    "googleCalendar": "Google Kalendář",
    "google": "Google Kalendář",
    "googleConnected": "Připojeno",
    "googleDisconnected": "Nepřipojeno",
    "googleConnectedHelp": "Nové připomínky lze automaticky synchronizovat s kalendářem.",
    "googleDisconnectedHelp": "Připojte Google Kalendář pro sladění připomínek a událostí.",
    "googleConnectFailed": "Nepodařilo se připojit Google Kalendář",
    "connected": "Připojeno",
    "disconnected": "Nepřipojeno",
    "connect": "Připojit",
    "disconnect": "Odpojit",
    "autoSync": "Automatická synchronizace nových připomínek",
    "autosync": "Automatická synchronizace nových připomínek",
    "subscription": "Předplatné",
    "trialUsed": "Zkušební doba: {{used}}/{{total}} použito",
    "trialStatus": "Zkušební doba dostupná",
    "activeStatus": "Aktivní předplatné",
    "expiredStatus": "Předplatné vypršelo",
    "unsubscribedStatus": "Nepředplaceno",
    "about": "O aplikaci",
    "version": "Verze",
    "logout": "Odhlásit se",
    "logoutTitle": "Odhlásit se",
    "logoutConfirm": "Opravdu se chcete odhlásit?",
    "noName": "Není nastaveno jméno",
    "serverConnection": "Připojení k serveru",
    "serverUrl": "URL serveru",
    "serverEdit": "Upravit",
    "saveReconnect": "Uložit a znovu připojit",
    "resetDefault": "Obnovit výchozí",
    "invalidServerUrlTitle": "Neplatná URL serveru",
    "invalidServerUrlMessage": "Zadejte platnou http nebo https URL serveru, např. https://example.com",
    "uiLanguageChangeFailed": "Nepodařilo se změnit jazyk aplikace. Zkuste to znovu.",
    "serverLanguageChangeFailed": "Nepodařilo se změnit jazyk chatu. Zkuste to znovu.",
    "timezoneChangeFailed": "Nepodařilo se změnit časové pásmo. Zkuste to znovu.",
    "autoSyncChangeFailed": "Nepodařilo se aktualizovat automatickou synchronizaci. Zkuste to znovu.",
    "nameChangeFailed": "Nepodařilo se aktualizovat zobrazované jméno. Zkuste to znovu.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detaily připomínky",
    "editTime": "Upravit čas",
    "rename": "Přejmenovat",
    "snooze": "Odložit",
    "snooze15": "Odložit o 15 minut",
    "pause": "Pozastavit",
    "pauseReminder": "Pozastavit připomínku",
    "resume": "Pokračovat",
    "resumeReminder": "Pokračovat v připomínce",
    "skip": "Přeskočit další",
    "skipOccurrence": "Přeskočit tuto událost",
    "syncGoogle": "Synchronizovat s Google",
    "delete": "Smazat",
    "deleteTitle": "Smazat připomínku",
    "deleteConfirm": "Tato připomínka bude trvale smazána.",
    "deleteRecurringTitle": "Smazat opakovanou připomínku",
    "deleteRecurringMessage": "Chcete přeskočit tuto událost nebo smazat celou sérii?",
    "deleteThisOccurrence": "Přeskočit tuto událost",
    "deleteEntireSeries": "Smazat celou sérii",
    "done": "Hotovo",
    "markDone": "Označit jako hotové",
    "undo": "Obnovit",
    "undoPrompt": "Potřebujete ji znovu aktivní? Obnovte ji nyní.",
    "recurring": "Opakující se",
    "nextRun": "Další spuštění",
    "oneTime": "Jednorázová",
    "pending": "Čeká",
    "sent": "Odesláno",
    "paused": "Pozastaveno",
    "active": "Aktivní",
    "snoozed": "Odloženo",
    "localTime": "Zobrazeno v místním čase",
    "recurrence": "Opakování",
    "created": "Vytvořeno",
    "tags": "Štítky",
    "fireCount": "Počet spuštění",
    "actions": "Akce",
    "none": "Žádné",
    "snoozeFailed": "Nepodařilo se odložit připomínku",
    "pauseFailed": "Nepodařilo se pozastavit připomínku",
    "resumeFailed": "Nepodařilo se pokračovat v připomínce",
    "skipFailed": "Nepodařilo se přeskočit připomínku",
    "doneFailed": "Nepodařilo se označit připomínku jako hotovou",
    "undoFailed": "Nepodařilo se obnovit stav připomínky",
    "deleteFailed": "Nepodařilo se smazat připomínku",
    "rescheduleTitle": "Přeplánovat?",
    "rescheduleMsg": "Tato připomínka je po termínu. Chcete ji přeplánovat?",
    "reschedule15": "Za 15 minut",
    "reschedule60": "Za 1 hodinu",
    "keepOverdue": "Nechat jak je"
  },
  "onboarding": {
    "slide1Title": "Vítejte ve FishMemory",
    "slide1Sub": "Váš osobní asistent připomínek — poháněný WhatsAppem a vytvořený pro vaši kapsu.",
    "slide2Title": "Stačí psát přirozeně",
    "slide2Sub": "Napište připomínky, jak je myslíte: „Připomeň mi zavolat mámě zítra v 15:00“ — o zbytek se postaráme.",
    "slide3Title": "Nic nezmeškáte",
    "slide3Sub": "Dostávejte včasná upozornění, organizujte pomocí štítků a mějte vše pod kontrolou.",
    "getStarted": "Začít",
    "next": "Další",
    "firstReminderTitle": "Vytvořte svou první připomínku!",
    "firstReminderHint": "Zkuste napsat něco jako:",
    "firstReminderExample": "Připomeň mi pít vodu zítra v 9:00",
    "gotIt": "Rozumím!",
    "notifRationaleTitle": "Buďte včas",
    "notifRationaleBody": "FishMemory potřebuje oznámení, aby vás včas upozornil. Dostanete jen upozornění na připomínky, které vytvoříte.",
    "notifRationaleAllow": "Povolit oznámení",
    "notifRationaleLater": "Možná později",
    "swipeHint": "Přejeďte doprava pro rychlé akce →",
    "calendarDragHint": "Táhněte pro rozšíření ↕"
  }
}
